import css from 'styled-jsx/css';

export const staticStyles = css`
  .consent-management-modal {
    padding: 20px;
    min-width: 300px;

    &__description {
      margin-bottom: 20px;
      font-size: 14px;
      line-height: 1.5;
      color: #333;
    }

    &__buttons {
      display: flex;
      gap: 10px;
      justify-content: flex-end;
    }
  }
`;
